import { GenericError } from './genericError.mjs';

const CONF_ERROR_TYPE = 'ConfigurationError';
/**
 * Ошибка конфигурации. Должна использоваться при конфигурации чего-либо.
 *
 * @example
 * ```js
 * // Проверка конфигурации окружения
 * const confProp = process.env.SOME_CONFIG_PROPERTY;
 *
 * if (!confProp) {
 *  return Err(new ConfigurationError({ message: 'Env value SOME_CONFIG_PROPERTY is empty' }))
 * }
 *
 * return Ok()
 * ```
 *
 * Пример из React
 *
 * ```tsx
 * function AppContext(props) {
 *  const mfRegistry = getMfRegistry();
 *
 *  // В этом случае паникуем, так приложение запустить невозможно
 *  if (!mfRegistry) {
 *    throw new ConfigurationError({ ... });
 *  }
 *
 *  return (<Context.Provider value={{ mfRegistry }}>{props.children}</Context.Provider>)
 * }
 * ```
 *
 * @export
 * @class ConfigurationError
 * @extends {GenericError}
 */
class ConfigurationError extends GenericError {
    static is(value) {
        return GenericError.is(value) && value.type === CONF_ERROR_TYPE;
    }
    static isLike(value) {
        return GenericError.is(value) && Object.getPrototypeOf(value).constructor.name === CONF_ERROR_TYPE;
    }
    constructor({ message, domain, details }) {
        super({
            type: CONF_ERROR_TYPE,
            message,
            domain,
            details,
        });
        Object.setPrototypeOf(this, ConfigurationError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ConfigurationError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}

export { CONF_ERROR_TYPE, ConfigurationError };
//# sourceMappingURL=configurationError.mjs.map
